import React, { type FC } from 'react'

import { GRID_VARIANT_SMALL, Grid, GridCell } from 'mailup-web-components'

import ActionDeleteCriterion from 'Pages/RecipientsList/components/filters/ActionDeleteCriterion'
import InputCritType from 'Pages/RecipientsList/components/filters/InputCritType'
import InputFilterMode from 'Pages/RecipientsList/components/filters/filters/InputFilterMode'
import InputFilters from 'Pages/RecipientsList/components/filters/filters/InputFilters'

interface CriterionFiltersProps {
  index: number
}

const CriterionFilters: FC<CriterionFiltersProps> = ({ index }) => {
  return (
    <Grid variant={GRID_VARIANT_SMALL} cols={12}>
      <GridCell span={3}>
        <InputCritType index={index} />
      </GridCell>
      <GridCell span={2}>
        <InputFilterMode index={index} />
      </GridCell>
      <GridCell span={6}>
        <InputFilters index={index} />
      </GridCell>
      <GridCell span={1}>
        <ActionDeleteCriterion index={index} />
      </GridCell>
    </Grid>
  )
}

export default CriterionFilters
